import CircularProgress from '@mui/material/CircularProgress';
import useStyles from './styles';

const PageLoader = () => {
  const { classes } = useStyles();
  return (
    <div className={classes.root}>
      <CircularProgress />
    </div>
  );
};

export default PageLoader;
